import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilter1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="filter-1, sort"><path d="M4.75 3C3.7835 3 3 3.7835 3 4.75V7.58579C3 8.04991 3.18437 8.49503 3.51256 8.82322L8.92678 14.2374C8.97366 14.2843 9 14.3479 9 14.4142V21.25C9 21.4844 9.10956 21.7053 9.29615 21.8471C9.48275 21.9889 9.72491 22.0354 9.95073 21.9726L14.4507 20.7226C14.7753 20.6325 15 20.3369 15 20V14.4142C15 14.3479 15.0263 14.2843 15.0732 14.2374L20.4874 8.82322C20.8156 8.49503 21 8.04991 21 7.58579V4.75C21 3.7835 20.2165 3 19.25 3H4.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFilter1;
